import React, { FC } from 'react';

export const ChatActivator: FC = ({ children }) => {
  const clickChatActivator = () => {
    const iframe = document.getElementById('launcher') as HTMLIFrameElement;
    const innerDoc = iframe?.contentDocument || iframe?.contentWindow?.document;
    innerDoc.getElementsByTagName('button')[0]?.click();
  };

  return (
    <span onClick={clickChatActivator}>
      {children}
      <style jsx>{`
        span {
          text-decoration: underline;
          cursor: pointer;
        }
      `}</style>
    </span>
  );
};
